import { useCallback, useContext } from "react";
import { UNSAFE_DataRouterContext as DataRouterContext, matchRoutes } from "react-router-dom";
import TelemetryContext from "logic/telemetry/TelemetryContext";
import { currentPathname, stripPrefixFromPathname, getPathnameWithoutId } from "util/URLUtils";
import { singleton } from "logic/singleton";
import useLocation from "routing/useLocation";
const retrieveCurrentRoute = (dataRouterContext) => {
  var _a, _b;
  if (!((_a = dataRouterContext == null ? void 0 : dataRouterContext.router) == null ? void 0 : _a.routes)) {
    return void 0;
  }
  const {
    router: { routes }
  } = dataRouterContext;
  const pathname = currentPathname();
  const matches = matchRoutes(routes, pathname);
  return stripPrefixFromPathname((_b = matches == null ? void 0 : matches.at(-1)) == null ? void 0 : _b.route.path);
};
const useSendTelemetry = () => {
  const { pathname } = useLocation();
  const { sendTelemetry } = useContext(TelemetryContext);
  const dataRouterContext = useContext(DataRouterContext);
  return useCallback(
    (eventType, event) => {
      const route = retrieveCurrentRoute(dataRouterContext);
      const baseEvent = {
        app_path_pattern: route,
        app_pathname: getPathnameWithoutId(pathname)
      };
      return sendTelemetry(eventType, { ...baseEvent, ...event });
    },
    [dataRouterContext, pathname, sendTelemetry]
  );
};
export default singleton("core.useSendTelemetry", () => useSendTelemetry);
